import axios from 'axios';
import localStorage from '../services/localStorage';
// V produkci běží API na stejném originu pod cestou /pos-api (nginx-proxy
// VIRTUAL_PATH prefix odstřihne). Lokální dev: http://host:port z .env.development.
const API_URL = process.env.REACT_APP_API_URL || '/pos-api';
const API_PORT = process.env.REACT_APP_API_PORT;
const hasScheme = /^https?:\/\//.test(API_URL);
const rawBase = hasScheme && API_PORT ? `${API_URL}:${API_PORT}` : API_URL;
const APP_API_URL = rawBase.endsWith('/') ? rawBase : `${rawBase}/`;
axios.interceptors.request.use((config) => {
  const token = localStorage.getAccessToken();
  if (token) {
    config.headers['Authorization'] = 'Bearer ' + token;
  }
  return config;
});

export const get = (path) => {
  let cancelToken = axios.CancelToken.source();
  return axios.get(APP_API_URL + path, {
    cancelToken: cancelToken.token,
  });
};

export const post = (path, body) => {
  let cancelToken = axios.CancelToken.source();
  return axios.post(
    APP_API_URL + path,
    { ...body },
    {
      cancelToken: cancelToken.token,
    },
  );
};

export const put = (path, body) => {
  let cancelToken = axios.CancelToken.source();
  return axios.put(
    APP_API_URL + path,
    { ...body },
    {
      cancelToken: cancelToken.token,
    },
  );
};

export const del = (path) => {
  let cancelToken = axios.CancelToken.source();
  return axios.delete(APP_API_URL + path, {
    cancelToken: cancelToken.token,
  });
};
